var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgVideoFile = function SvgVideoFile(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1H3.5C2.83696 1 2.20107 1.26339 1.73223 1.73223C1.26339 2.20107 1 2.83696 1 3.5V23.5C1 24.163 1.26339 24.7989 1.73223 25.2678C2.20107 25.7366 2.83696 26 3.5 26H18.5C19.163 26 19.7989 25.7366 20.2678 25.2678C20.7366 24.7989 21 24.163 21 23.5V9.75L12.25 1Z",
    stroke: "#E2E2E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1V9.75H21",
    stroke: "#E2E2E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1465 16.2523C16.085 16.0067 15.9598 15.7817 15.7836 15.6C15.6073 15.4182 15.3862 15.2863 15.1426 15.2173C14.2526 15 10.6924 15 10.6924 15C10.6924 15 7.13225 15 6.24221 15.238C5.99861 15.307 5.77752 15.4389 5.60125 15.6207C5.42499 15.8024 5.2998 16.0274 5.23833 16.273C5.07544 17.1762 4.99576 18.0925 5.0003 19.0103C4.99449 19.9351 5.07417 20.8584 5.23833 21.7684C5.3061 22.0064 5.43409 22.2228 5.60994 22.3969C5.7858 22.5709 6.00357 22.6967 6.24221 22.762C7.13225 23 10.6924 23 10.6924 23C10.6924 23 14.2526 23 15.1426 22.762C15.3862 22.693 15.6073 22.5611 15.7836 22.3794C15.9598 22.1976 16.085 21.9726 16.1465 21.727C16.3081 20.8306 16.3878 19.9213 16.3845 19.0103C16.3903 18.0856 16.3106 17.1623 16.1465 16.2523Z",
    fill: "#E2E2E2",
    fillOpacity: 0.12,
    stroke: "#E2E2E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52808 20.7025L12.5035 19.0103L9.52808 17.3182V20.7025Z",
    fill: "#E2E2E2",
    fillOpacity: 0.12,
    stroke: "#E2E2E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-file.67492cb4.svg";
export { ForwardRef as ReactComponent };